module.exports = __webpack_public_path__ + "10fa79406e7853233316ee1ffda62115.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-33.jpg
// module id = 1175
// module chunks = 0